<div class="row mt-1 table-row" [formGroup]="form">
    <div class="col-md-2">
        <select hznTestId="discount-type-select" (change)="changeType($event.target.value)" class="form-control">
            @for (type of getDiscountTypes(); track type) {
                <option
                    [value]="type"
                    [selected]="form.controls.type.value == type"
                >
                    {{ translateType(type) }}
                </option>
            }
        </select>
    </div>
    <div class="col-md-2">
        <input
            class="form-control"
            type="text"
            hznTestId="discount-name-input"
            formControlName="name"
            maxlength="160"
        />
    </div>
    <div class="col-md-4">
        @if (isEarlyBird || isEnrollmentDays) {
            <div>
                <div class="row">
                    <div class="col-2">
                        {{ discountDetailsLabel() }}
                    </div>
                    <div class="col-5">
                        <bcui-date-picker-input2
                            class="date-picker"
                            hznTestId="discount-date-from"
                            formControlName="dateFrom"
                            name="dateFrom"
                        >
                        </bcui-date-picker-input2>
                    </div>
                    <div class="col-5">
                        <bcui-date-picker-input2
                            class="date-picker"
                            hznTestId="discount-date-to"
                            formControlName="dateTo"
                            name="dateTo"
                        >
                        </bcui-date-picker-input2>
                    </div>
                </div>
            </div>
        }

        @if (isNumberOfDays) {
            <div>
                <div class="row">
                    <div class="col-4">
                        {{ discountDetailsLabel() }}
                    </div>
                    <div class="col-4">
                        <input
                            class="form-control value-input"
                            type="text"
                            [mask]="mask.daysCountMask"
                            hznTestId="discount-days-from"
                            formControlName="daysFrom"
                        />
                    </div>
                    <div class="col-4">
                        <input
                            class="form-control value-input"
                            type="text"
                            [mask]="mask.daysCountMask"
                            hznTestId="discount-days-to"
                            formControlName="daysTo"
                        />
                    </div>
                </div>
            </div>
        }

        @if (isSiblings) {
            <div>
                <div class="row">
                    <div class="col-4">{{ discountDetailsLabel() }}</div>
                    <div class="col-4">
                        <input
                            class="form-control value-input"
                            type="text"
                            [mask]="mask.daysCountMask"
                            placeholder="min"
                            hznTestId="discount-min-days"
                            formControlName="minimumNumberOfDays"
                        />
                    </div>
                    <div class="col-4">
                        <input
                            class="form-control value-input"
                            type="text"
                            [mask]="mask.daysCountMask"
                            placeholder="max"
                            hznTestId="discount-max-days"
                            formControlName="maximumNumberOfDays"
                        />
                    </div>
                </div>
            </div>
        }

        @if (isPif) {
            <div>
                <div class="row">
                    <div class="col-4">{{ discountDetailsLabel() }}</div>
                    <div class="col-4">
                        <input
                            class="form-control value-input"
                            type="text"
                            [mask]="mask.daysCountMask"
                            placeholder="min"
                            formControlName="minimumNumberOfCamps"
                        />
                    </div>
                    <div class="col-4">
                        <input
                            class="form-control value-input"
                            type="text"
                            [mask]="mask.daysCountMask"
                            placeholder="max"
                            formControlName="maximumNumberOfCamps"
                        />
                    </div>
                </div>
            </div>
        }

        @if (isTier) {
            <div>
                <div class="row">
                    <div class="col-4">{{ discountDetailsLabel() }}</div>
                    <div class="col-8">
                        <select
                            hznTestId="discount-tier-select"
                            (change)="changeTier($event.target.value)"
                            class="form-control"
                        >
                            @for (tier of context.membershipTiers; track tier) {
                                <option
                                    [value]="tier"
                                    [selected]="
                                        form.controls.membershipTier.value ==
                                        tier
                                    "
                                >
                                    {{ translateTier(tier) }}
                                </option>
                            }
                        </select>
                    </div>
                </div>
            </div>
        }
    </div>
    @if (isCartLevel) {
        <div class="col-md-1">
            <input
                class="form-control value-input"
                type="text"
                [mask]="mask.orderMask"
                placeholder="order"
                hznTestId="discount-order"
                formControlName="applicationOrder"
            />
        </div>
    }
    <div
        [ngClass]="{
            'col-md-1': form.controls.isCartLevel.value,
            'col-md-2': form.controls.isPricingLevel.value,
        }"
    >
        <input
            class="form-control value-input"
            type="text"
            [mask]="mask.percentValueMask"
            suffix="%"
            min="0"
            max="100"
            placeholder="value"
            hznTestId="discount-value-input"
            formControlName="valuePercent"
        />
    </div>
    <div class="col-md-2">
        <button
            class="btn btn-success btn-action pull-right"
            [disabled]="!isFormValid()"
            type="button"
            bcClick
            hznTestId="discount-save"
            (clicked)="save()"
        >
            {{ "General.Save" | translate }}
        </button>
        <button
            class="btn btn-danger btn-action pull-right mr-1"
            type="button"
            bcClick
            (clicked)="cancel()"
        >
            {{ "General.Cancel" | translate }}
        </button>
    </div>
</div>
